import React from 'react';
import { FREESTAR_RECOVERED_SCRIPT_ID, FREESTAR_RECOVERED_SCRIPT_SOURCE } from './freestarRecoveredScript';

/**
 * Freestar Recovered (ad-block recovery) head script.
 * PubOS Site Config → Freestar Recovered.
 * `?v=` is a one-time cache key so browsers that still hold the pre-fix JSON get the current wall; bump or drop the prepend once that cohort is gone.
 */
export const FreestarRecovered: React.FC = () => (
  <script
    // eslint-disable-next-line benzinga/no-unsanitized-innerhtml -- static Freestar Recovered JS; sanitizeHTML is for HTML and would corrupt JS
    dangerouslySetInnerHTML={{ __html: FREESTAR_RECOVERED_SCRIPT_SOURCE }}
    data-cfasync="false"
    id={FREESTAR_RECOVERED_SCRIPT_ID}
    type="text/javascript"
  />
);
